import React from "react";
import {
  SCROLL_OFFSET,
  ARTICLE_COLUMN,
  H2,
  BODY,
  STACK_GAP,
  SOFT_PANEL,
} from "./sections";

const WhatMakesDifferentSection = () => {
  return (
    <section
      id="what-makes-ai-voice-typing-different"
      style={{ scrollMarginTop: `${SCROLL_OFFSET}px` }}
      className={ARTICLE_COLUMN}
    >
      <h2 className={H2}>What Makes AI Voice Typing Different</h2>

      <p className={`${STACK_GAP} ${BODY}`}>
        An AI voice typing tool sits on top of your operating system rather
        than inside one app. It works the same way whether you&apos;re writing
        an email in Gmail, dropping notes into Slack, drafting a doc in Google
        Docs, or prompting an AI chat tool. Instead of just converting audio to
        text, it applies a language model to clean up filler words, fix
        grammar, match a tone you specify, and format the output for whatever
        you&apos;re writing.
      </p>

      <p className={`${STACK_GAP} ${BODY}`}>
        Zero Typing, for example, works across Google Docs, Gmail, Slack, and
        AI chat tools like ChatGPT, Claude, and Gemini, with a single dictation
        flow rather than a different tool for each app. It also includes a
        Personal Dictionary for names, technical terms, and custom spellings,
        automatic language detection, and prompt-based rewriting (Writing
        Tone, Fix Grammar, Transcript Only, Ask GPT, and custom prompts) so the
        output is publish-ready rather than a raw transcript you still have to
        edit by hand.
      </p>

      {/* Pull-quote style takeaway - the one line the whole article turns on */}
      <div className={`mt-[30.05px] ${SOFT_PANEL} p-[20px] sm:p-[25.76px]`}>
        <p className="font-jakarta text-[18px] font-semibold leading-[28px] tracking-[-0.2px] text-[#0A0D16] sm:text-[20px] sm:leading-[30px]">
          That&apos;s the core difference: built-in dictation gives you a
          transcript. AI voice typing gives you a finished draft.
        </p>
      </div>
    </section>
  );
};

export default WhatMakesDifferentSection;
